// Bausteine des Urknalls, geteilt von der Registrierung (big-bang.component)
// und dem Modul-Dialog (features/module-dialog.component): derselbe Lichtpunkt,
// dieselben Partikel — damit beide nach demselben Universum aussehen.

export interface Particle {
  x: number; y: number;
  vx: number; vy: number;
  r: number;       // radius
  a: number;       // base alpha
  tw: number;      // twinkle phase
  tws: number;     // twinkle speed
}

/** Weicher Leuchtpunkt, einmal gezeichnet und dann nur noch skaliert kopiert. */
export function makeGlowSprite(): HTMLCanvasElement {
  const s = document.createElement('canvas');
  s.width = s.height = 64;
  const g = s.getContext('2d')!;
  const grad = g.createRadialGradient(32, 32, 0, 32, 32, 32);
  grad.addColorStop(0, 'rgba(255,255,255,1)');
  grad.addColorStop(0.22, 'rgba(232,238,255,0.55)');
  grad.addColorStop(1, 'rgba(180,200,255,0)');
  g.fillStyle = grad;
  g.fillRect(0, 0, 64, 64);
  return s;
}

/** `n` Partikel, die von (cx, cy) in alle Richtungen auseinanderfliegen. */
export function burst(cx: number, cy: number, n: number): Particle[] {
  const out: Particle[] = [];
  for (let i = 0; i < n; i++) {
    const angle = Math.random() * Math.PI * 2;
    const speed = Math.pow(Math.random(), 0.6) * 10 + 0.5; // bias to the outside
    const big = Math.random() < 0.12;
    out.push({
      x: cx, y: cy,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed,
      r: big ? 1.8 + Math.random() * 1.6 : 0.7 + Math.random() * 1.1,
      a: 0.55 + Math.random() * 0.45,
      tw: Math.random() * Math.PI * 2,
      tws: 0.002 + Math.random() * 0.004,
    });
  }
  return out;
}

/** Ein Schritt: weiterfliegen, abbremsen, funkeln. Gibt die Deckkraft zurueck. */
export function step(q: Particle): number {
  q.x += q.vx; q.y += q.vy;
  q.vx *= 0.955; q.vy *= 0.955;
  q.tw += q.tws * 16;
  return q.a * (0.75 + 0.25 * Math.sin(q.tw));
}

export function drawGlow(ctx: CanvasRenderingContext2D, sprite: HTMLCanvasElement, x: number, y: number, r: number, alpha: number): void {
  ctx.globalAlpha = Math.max(0, Math.min(1, alpha));
  ctx.drawImage(sprite, x - r, y - r, r * 2, r * 2);
}
